import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { RECORDS_PER_PAGE_OPTIONS } from '../../../../utils/constants';

import Dropdown from '../../../common/inputs/dropdown/Dropdown';
import Button from '../../../common/button/Button';
import Table from '../../../common/table/Table';

import './account-management.scss';

const AccountManagement = ({
  accounts,
  dropdownAccounts,
  initialFilters,
  currentPage,
  totalPages,
  retrieveAccounts,
}) => {
  const [recordsPerPage, setRecordsPerPage] = useState({ label: 20, value: 20 });
  const [status, setStatus] = useState(undefined);
  const [account, setAccount] = useState(undefined);
  const [type, setType] = useState(undefined);

  const navigate = useNavigate();

  const filters = useRef({});

  useEffect(() => {
    setRecordsPerPage(initialFilters.recordsPerPage);
    setStatus(initialFilters.status);
    setAccount(initialFilters.account);
    setType(initialFilters.type);

    filters.current = initialFilters;
  }, [initialFilters]);

  const handleRowClick = (account) => {
    navigate(`/admin/account-management/${account.externalReference}`);
  };

  const haveFiltersChanged = () => {
    let definedKeys = 0;
    for (let key in filters.current) {
      if (filters.current[key] !== undefined && filters.current[key] !== null && filters.current[key] !== '') {
        definedKeys++;
      }
    }

    if (filters.current.page !== 0 || filters.current.recordsPerPage.value !== 20 || definedKeys !== 2) {
      return true;
    }

    return false;
  };

  const applyFilters = (page) => {
    filters.current = {
      recordsPerPage,
      status,
      page,
      account,
      type,
    };

    retrieveAccounts(filters.current);
  };

  const removeFilters = () => {
    const recordsPerPage = RECORDS_PER_PAGE_OPTIONS[1];

    filters.current = {
      page: 0,
      recordsPerPage,
    };

    setRecordsPerPage(recordsPerPage);
    setStatus(undefined);
    setType(undefined);

    retrieveAccounts(filters.current);
  };

  return (
    <section className="account-management" data-testid="account-management">
      <section className="account-management__filter">
        <section className="account-management__filter__filters">
          <p>Filter</p>

          <label htmlFor="records-per-page">Records per Page</label>
          <Dropdown
            name="records-per-page"
            value={recordsPerPage}
            options={RECORDS_PER_PAGE_OPTIONS}
            onChange={(option) => setRecordsPerPage(option)}
          />

          <label htmlFor="account-status">Status</label>
          <Dropdown
            name="account-status"
            value={status}
            options={[
              { label: 'Verified', value: 'verified' },
              { label: 'Not Verified', value: 'not verified' },
            ]}
            onChange={(option) => setStatus(option)}
          />

          <label htmlFor="account">Account</label>
          <Dropdown
            name="account"
            value={account}
            options={dropdownAccounts}
            onChange={(option) => setAccount(option)}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.externalReference}
          />

          <label htmlFor="account-type">Account Type</label>
          <Dropdown
            name="account-type"
            value={type}
            options={[
              { label: 'Buyer', value: 'buyer' },
              { label: 'Seller', value: 'seller' },
              { label: 'Broker', value: 'broker' },
            ]}
            onChange={(option) => setType(option)}
          />
        </section>

        <div className="account-management__filter__button-container">
          <Button onClick={() => applyFilters(0)}>Apply Filter</Button>
          {haveFiltersChanged() && <Button onClick={() => removeFilters()}>Remove Filter</Button>}
        </div>
      </section>

      <section className="account-management__table">
        <section className="account-management__table__header">
          <h1>Accounts</h1>
        </section>

        <section className="account-management__table__container">
          <Table
            data={accounts}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={applyFilters}
            onRowClick={handleRowClick}
            emptyMessage="No accounts found"
            hiddenColumns={['externalReference']}
          />
        </section>
      </section>
    </section>
  );
};

AccountManagement.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
  dropdownAccounts: PropTypes.arrayOf(PropTypes.shape({})),
  initialFilters: PropTypes.shape({}).isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  retrieveAccounts: PropTypes.func.isRequired,
};

AccountManagement.defaultProps = {
  accounts: [],
  dropdownAccounts: [],
};

export default AccountManagement;
